// import Swiper JS
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

// === New logic to sync slide heights with their parent container, only for window width < 790px ===
const updateBoxesGridSliderMobHeight = () => {
  if (window.innerWidth < 790) {
    $('.boxes_grid_slider_mob .swiper-slide').css('height', 'fit-content');
    $('.boxes_grid_slider_mob .box_card').css('height', 'fit-content');
    // Get the height of .boxes_grid_slider_mob .swiper-wrapper
    var height = $('.boxes_grid_slider_mob .swiper-wrapper').outerHeight();
    console.log('Height of .boxes_grid_slider_mob .swiper-wrapper:', height);

    // Set the height of .boxes_grid_slider_mob .swiper-slide
    $('.boxes_grid_slider_mob .swiper-slide').css('height', height + 'px');
    console.log('Set height of .boxes_grid_slider_mob .swiper-slide:', height);
    // Set the height of .boxes_grid_slider_mob .box_card to (height - 80) px
    $('.boxes_grid_slider_mob .box_card').css('height', (height - 80) + 'px');
    console.log('Set height of .boxes_grid_slider_mob .box_card:', height - 80);
  } else {
    // Reset heights to their default (auto)
    $('.boxes_grid_slider_mob .swiper-slide').css('height', '');
    $('.boxes_grid_slider_mob .box_card').css('height', '');
    console.log('Reset .swiper-slide and .box_card heights to default (auto)');
  }
};

// Run on initial page load (after assets/images have loaded)
window.addEventListener('load', updateBoxesGridSliderMobHeight);
// Run whenever the window is resized
window.addEventListener('resize', updateBoxesGridSliderMobHeight);

// Insert Swiper initialisation for .slider_scroll_mob_only (retain existing configuration)
var cardSlider = new Swiper('.slider_scroll_mob_only', {
  slidesPerView: 1.2,
  spaceBetween: 20,
  autoplay: {
    delay: 15000,
    disableOnInteraction: false,
  },
  // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//   },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1220: {
      slidesPerView: 3,
    }
  },
  on: {
    init: () => {
      updateBoxesGridSliderMobHeight();
    },
    resize: () => {
      updateBoxesGridSliderMobHeight();
    }
  }
  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // }
});


// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

var cardSlider = new Swiper('.homepage_mob_slider', {
  slidesPerView: 1.2,
  spaceBetween: 20,
  // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//   },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    1220: {
      slidesPerView: 4,
    }
  }
  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // }
});
